export default __webpack_public_path__ + "static/CorprateHp_16-7d0ee04aebd6bbf1732ad169dd2b67a3.jpg";